import { Dialog } from 'quasar'
import ConfirmationDialog from 'src/components/dialogs/common/ConfirmationDialog.vue'
import TwoFactorDialog from 'src/components/dialogs/common/TwoFactorDialog.vue'
import { parseBoolean } from '.'
import NpsVoteDialog from 'src/components/dialogs/nps/NpsResponseDialog.vue'
import { api } from 'src/boot/axios'
import ConfirmationDiffDialog from 'src/components/dialogs/common/ConfirmationDiffDialog.vue'
import isEqual from 'lodash.isequal'

export const ConfirmationDialogExitConfirmation = ({
  title = 'Alterações não salvas',
  message = 'Existem alterações que não foram salvas, deseja sair mesmo assim?',
  okLabel = 'Voltar à edição'
} = {}) => {
  return new Promise((resolve) => {
    Dialog.create({
      component: ConfirmationDialog,
      componentProps: {
        title,
        message,
        okLabel,
        cancelLabel: 'Sair',
        persistent: true,
        reverse: true
      }
    })
      .onOk(() => {
        resolve(false)
      })
      .onCancel(() => {
        resolve(true)
      })
  })
}

export const openTwoFactorDialog = async (props) => {
  if (parseBoolean(process.env.TWO_FACTOR_ENABLED, false)) {
    return new Promise((resolve, reject) => {
      Dialog.create({
        component: TwoFactorDialog,
        componentProps: props
      })
        .onOk(resolve)
        .onCancel(reject)
    })
  } else {
    return await props.onCodeSubmit(null)
  }
}

export const openNpsVoteDialog = async () => {
  const { data } = await api.get('nps/started-nps', {
    customErrorHandlers: {
      404: () => {},
      422: () => {},
      403: () => {}
    }
  })

  Dialog.create({
    component: NpsVoteDialog,
    componentProps: {
      npsId: data.id
    }
  })
}

export const openConfirmationDiffDialog = (initialData, updatedData, fieldsProps, jsonFields, arrayFields, returnWith, keysToIgnore, htmlFields) => {
  if (isEqual(initialData, updatedData)) return true

  return new Promise((resolve, reject) => {
    Dialog.create({
      component: ConfirmationDiffDialog,
      componentProps: {
        oldObject: initialData,
        newObject: updatedData,
        fieldsProps,
        jsonFields,
        arrayFields,
        returnWith,
        keysToIgnore,
        htmlFields
      }
    })
      .onOk(() => {
        resolve(true)
      })
      .onCancel(() => {
        reject(false)
      })
  })
}
